import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createElement } from 'react';
import { useHTMLProps } from '../html/use-props.mjs';
import { filterProps } from './utils/filter-props.mjs';
import { isSVGComponent } from './utils/is-svg-component.mjs';
import { useSVGProps } from '../svg/use-props.mjs';
function createUseRender() {
  var forwardMotionProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var useRender = function useRender(Component, props, projectionId, ref, _ref, isStatic) {
    var latestValues = _ref.latestValues;
    var useVisualProps = isSVGComponent(Component) ? useSVGProps : useHTMLProps;
    var visualProps = useVisualProps(props, latestValues, isStatic, Component);
    var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
    var elementProps = _objectSpread(_objectSpread(_objectSpread({}, filteredProps), visualProps), {}, {
      ref: ref
    });
    if (projectionId) {
      elementProps["data-projection-id"] = projectionId;
    }
    return createElement(Component, elementProps);
  };
  return useRender;
}
export { createUseRender };